import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';

const LandingPageFooter = () => {
  return (
    <footer className="bg-slate-900 border-t border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <img 
              src="/logo-white.png" 
              alt="Global Filing Protection®" 
              className="h-8 w-auto"
            />
            <p className="text-gray-400 text-sm">
              © 2025 Global Filing Protection®. All rights reserved.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a 
              href="tel:+18332020812"
              className="flex items-center text-amber-500 hover:text-amber-400 font-semibold transition-colors"
            >
              <Phone className="h-4 w-4 mr-2" />
              <span className="text-sm">+1-833-202-0812</span>
            </a>
            <div className="hidden sm:block text-gray-600">|</div>
            <a 
              href="mailto:info@globalfilingprotection.com"
              className="flex items-center text-amber-500 hover:text-amber-400 font-semibold transition-colors"
            >
              <Mail className="h-4 w-4 mr-2" />
              <span className="text-sm">info@globalfilingprotection.com</span>
            </a>
            <div className="hidden sm:block text-gray-600">|</div>
            <Link to="/privacy-policy" className="text-gray-400 hover:text-amber-500 text-sm transition-colors">
              Privacy Policy
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/terms-of-service" className="text-gray-400 hover:text-amber-500 text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingPageFooter;
